// Constant variables here has been inlined in css from EditorContentContainer, if you need to make
// update here, please also update packages/editor/editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx
export const TaskDecisionSharedCssClassName = {
	DECISION_CONTAINER: 'decisionItemView-content-wrap',
	TASK_CONTAINER: 'taskItemView-content-wrap',
	//NOTE: value is a selector (data attribute), not a class name
	TASK_LIST_CONTAINER: '[data-node-type="actionList"]',
	TASK_ITEM: 'task-item',
	TASK_CHECKBOX_CONTAINER: 'task-item-checkbox-wrap',
};
